export default "__VITE_ASSET__BurrqkY8__"